import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, onMounted, onErrorCaptured } from "vue";
import LoginPanel from "@/components/general/access-layer/LoginPanel.vue";
import Bootstrap from "@/components/general/access-layer/Bootstrap.vue";
import InnPopup from "@/components/ds/popup/Popup.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessLayer',
  setup(__props) {

const router = useRouter();

const hasAccess = ref(false);
const errorMessage = ref<string>("");
const event = ref(null as PromiseRejectionEvent | null);

const handleError = async (error: any) => {
    console.log(error);
    switch (typeof error) {
        case "object":
            if (
                error.response &&
                error.response.status &&
                error.response.status === 401
            ) {
                localStorage.token = "";
                hasAccess.value = false;
                // refresh to clear all state
                router.go();
            } else {
                if (error.message) {
                    errorMessage.value = error.message;
                } else {
                    errorMessage.value = error;
                }
            }

            break;
        case "string":
        default:
            errorMessage.value = error;
            break;
    }
};

onErrorCaptured((error: Error) => {
    handleError(error);
    return false;
});

const atClose = () => {
    errorMessage.value = "";
};

const atSuccess = () => {
    hasAccess.value = true;
};

window.addEventListener("unhandledrejection", (ev: PromiseRejectionEvent) => {
    event.value = ev;
    console.dir(ev.reason);
    handleError(ev.reason);
    ev.preventDefault();
});

onMounted(async () => {
    if (localStorage.token) {
        atSuccess();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (hasAccess.value)
      ? (_openBlock(), _createBlock(Bootstrap, { key: 0 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }))
      : (_openBlock(), _createBlock(LoginPanel, {
          key: 1,
          onSuccess: atSuccess
        })),
    (errorMessage.value.length)
      ? (_openBlock(), _createBlock(InnPopup, {
          key: 2,
          "close-button": "",
          onClose: atClose
        }, {
          title: _withCtx(() => [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _cache[0] || (_cache[0] = _createTextVNode(" Oops... er ging iets mis "))
            ])
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", { innerHTML: errorMessage.value }, null, 8, _hoisted_1)
          ]),
          footer: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer", { atClose: atClose })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})